var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.181208 7.03125L0.181208 6.97266C0.0604026 7.08984 -3.17591e-07 7.26562 -3.27835e-07 7.5C-3.35519e-07 7.67578 0.0604025 7.85156 0.181208 8.02734L7.30872 14.8242C7.42953 14.9414 7.55033 15 7.79195 15C7.97315 15 8.15436 14.9414 8.33557 14.8242L8.75839 14.3555C8.87919 14.2383 8.9396 14.0625 8.9396 13.8867C8.9396 13.6523 8.87919 13.4766 8.75839 13.3594L2.59732 7.5L8.75839 1.64062C8.87919 1.46484 9 1.28906 9 1.11328C9 0.878906 8.87919 0.761719 8.75839 0.644531L8.33557 0.175781C8.15436 0.0585937 7.97315 -4.48848e-08 7.79195 -5.28057e-08C7.55034 -6.33668e-08 7.42953 0.0585937 7.30872 0.234375L0.181208 7.03125Z",
    fill: "#005A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.2e19e6d83512e3d5963cc4f8b88faa02.svg";
export { ForwardRef as ReactComponent };